/**
 * 时间格式化工具
 * 统一处理时区问题
 */

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

// 扩展 dayjs 插件
dayjs.extend(utc)
dayjs.extend(timezone)

// 从环境变量获取时区，默认菲律宾时区
const TIMEZONE = import.meta.env.VITE_TIME_ZONE || 'Asia/Manila'

/**
 * 格式化时间为指定时区
 */
export function formatTime(time: string | number | Date, formatStr = 'MM/DD HH:mm') {
  if (!time) return ''
  return dayjs(time).tz(TIMEZONE).format(formatStr)
}

/**
 * 格式化日期时间为指定时区
 */
export function formatDateTime(time: string | number | Date, formatStr = 'YYYY-MM-DD HH:mm:ss') {
  if (!time) return ''
  return dayjs(time).tz(TIMEZONE).format(formatStr)
}

/**
 * 格式化日期为指定时区
 */
export function formatDate(time: string | number | Date, formatStr = 'YYYY-MM-DD') {
  if (!time) return ''
  return dayjs(time).tz(TIMEZONE).format(formatStr)
}

/**
 * 获取当前时间
 */
export function now() {
  return dayjs().tz(TIMEZONE)
}

/**
 * 获取今天的开始时间
 */
export function getStartOfToday() {
  return dayjs().tz(TIMEZONE).startOf('day').format('YYYY-MM-DD 00:00:00')
}

/**
 * 获取今天的结束时间
 */
export function getEndOfToday() {
  return dayjs().tz(TIMEZONE).endOf('day').format('YYYY-MM-DD 23:59:59')
}

/**
 * 获取N天前的开始时间
 */
export function getStartOfDaysAgo(days: number) {
  return dayjs().tz(TIMEZONE).subtract(days, 'day').startOf('day').format('YYYY-MM-DD 00:00:00')
}

/**
 * 获取N天前的结束时间
 */
export function getEndOfDaysAgo(days: number) {
  return dayjs().tz(TIMEZONE).subtract(days, 'day').endOf('day').format('YYYY-MM-DD 23:59:59')
}

/**
 * 获取指定日期的开始时间
 */
export function getStartOfDay(date: string | number | Date) {
  return dayjs(date).tz(TIMEZONE).startOf('day').format('YYYY-MM-DD HH:mm:ss')
}

/**
 * 获取指定日期的结束时间
 */
export function getEndOfDay(date: string | number | Date) {
  return dayjs(date).tz(TIMEZONE).endOf('day').format('YYYY-MM-DD HH:mm:ss')
}

/**
 * 获取日期选项
 */
export function getDateOptions() {
  return [
    { label: '今天', value: getStartOfToday() },
    { label: '最近3天', value: getStartOfDaysAgo(2) },
    { label: '最近5天', value: getStartOfDaysAgo(4) },
    { label: '最近7天', value: getStartOfDaysAgo(6) },
  ]
}

/**
 * 根据结算类型获取时间范围
 */
export function getTimeRangeBySettle(settle: number) {
  switch (settle) {
    case 1: // 日
      return {
        startTime: getStartOfToday(),
        endTime: getEndOfToday()
      }
    case 2: // 周
      return {
        startTime: getStartOfDaysAgo(7),
        endTime: getEndOfToday()
      }
    case 3: // 月
      return {
        startTime: getStartOfDaysAgo(30),
        endTime: getEndOfToday()
      }
    default:
      return {
        startTime: getStartOfToday(),
        endTime: getEndOfToday()
      }
  }
}
